import { render, staticRenderFns } from "./Moscow.vue?vue&type=template&id=39b34024&"
import script from "./Moscow.vue?vue&type=script&lang=js&"
export * from "./Moscow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports